import ActionTypes from '@constants/action_types.js'
import { receiveEmbedKeys } from './embed_key_actions.js'

export function handleLoadEmbedKeySuccess(res) {
  return dispatch => {
    const parsedJSON = res.data
    const obj = {
      [parsedJSON.timeline_id]: parsedJSON,
    }
    dispatch(receiveEmbedKeys(obj))
    dispatch(loadSuccess())
  }
}

export function handleLoadEmbedKeyError(err) {
  return (dispatch, getState) => {
    dispatch(loadFail())
  }
}

export function loadSuccess() {
  return {
    type: ActionTypes.LOAD_EMBED_KEY_SUCCESS,
  }
}

export function loadFail() {
  return {
    type: ActionTypes.LOAD_EMBED_KEY_FAIL,
  }
}
